import React, { Component } from "react";
import { Row, Col, Table, Modal, Image, Card, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
var dateFormat = require("dateformat");

class ExpiryReturnsView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itempage: 0,
      itemsperPage: 5,
      actionDone: false,
      approvedQty: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ProductReturnDtls !== this.props.ProductReturnDtls) {
      const approvedQty = {};

      this.props.ProductReturnDtls?.forEach((item) => {
        approvedQty[item.id] = item.approvedQntty ?? item.qntty;
      });

      this.setState({ approvedQty });
    }
  }

  itemsPageClick = (ev) => {
    const selecteditemPage = ev.selected;
    this.props.itempageSelected({
      item: this.props.PurchaseReturnsToShow,
      page: selecteditemPage + 1,
    });
    this.setState({ itempage: selecteditemPage });
  };

  resetitemPage = () => {
    this.setState({
      itempage: 0,
    });
  };

  exportToExcel = () => {
    const { PurchaseReturnsToShow, ProductReturnDtls } = this.props;
    const data = PurchaseReturnsToShow?.item;
    if (!data || !ProductReturnDtls || ProductReturnDtls.length === 0) {
      alert("No data available");
      return;
    }

    const excelData = ProductReturnDtls.map((item, index) => ({
      "Order No": data.orderNo || "",
      "Chemist Name": data.orderFrom?.fullName || "",
      "Chemist Mobile": data.orderFrom?.mobileNo || "",
      "Chemist Organization": data.orderFrom?.orgName || "",
      "Distributor Organization": data.orderTo?.orgName || "",
      "Item Code": item.itemCode?.drugCode || "",
      "Item Name": item.itemName || "",
      "Batch No": item.batchNo || "",
      "Invoice No": item.purchaseInvoiceNo || "",
      "Purchase Date": item.purchaseDate
        ? dateFormat(item.purchaseDate, "dd-mmm-yyyy")
        : "",
      "Expiry Date": item.expiryDate
        ? dateFormat(item.expiryDate, "dd-mmm-yyyy")
        : "",
      "Unit Price": item.price || 0,
      "Order Quantity": item.qntty || 0,
      "Approved Quantity": item.approvedQntty || 0,
      "GST %": item.taxPercentage || 0,
      "GST Amount": item.taxAmount || 0,
      "Offer": item.offer || "-",
      "Claim Amount": item.claimAmountWithTax || 0,
      "Approved Amount": item.approvedAmount || 0,
    }));


    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Expiry Return Details");
    XLSX.writeFile(workbook, `Expiry_Return_${data.orderNo || "Details"}.xlsx`);
  };

  createPdf = () => {
    let value = this.props.PurchaseReturnsToShow;
    this.props.pdfreturnFullData(value);
  };

  renderOfferCell = (offer) => {
    const offerText = offer || "-";
    const displayText =
      offerText.length > 50 ? `${offerText.substring(0, 50)}...` : offerText;

    return (
      <td className="cmn_Cap" title={offerText}>
        <div
          style={{
            maxWidth: "160px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {displayText}
        </div>
      </td>
    );
  };

  accept = () => {
    const approvedAmountMap = {};
    const approvedTaxMap = {};
    let totalApprovedAmount = 0;
    let totalClaimAmount = 0;

    this.props.ProductReturnDtls?.forEach((item) => {
      const qty = Number(this.state.approvedQty[item.id] ?? 0);
      const price = Number(item.price ?? 0);
      const taxPer = Number(item.taxPercentage ?? 0);

      const base = qty * price;
      const tax = (base * taxPer) / 100;
      const approvedAmount = base + tax;

      approvedAmountMap[item.id] = approvedAmount;
      approvedTaxMap[item.id] = tax;

      totalApprovedAmount += approvedAmount;
      totalClaimAmount += Number(item.claimAmountWithTax ?? 0);
    });

    this.props.returnaccept({
      order: this.props.PurchaseReturnsToShow,
      approvedQtyMap: this.state.approvedQty,
      approvedAmountMap,
      approvedTaxMap,
      totalApprovedAmount,
      totalClaimAmount,
    });

    this.props.close();
  };

  reject = () => {
    const approvedAmountMap = {};
    let totalClaimAmount = 0;

    this.props.ProductReturnDtls?.forEach((item) => {
      approvedAmountMap[item.id] = 0;
      totalClaimAmount += Number(item.claimAmountWithTax ?? 0);
    });

    this.props.returnrejected({
      order: this.props.PurchaseReturnsToShow,
      approvedQtyMap: this.state.approvedQty,
      approvedAmountMap,
      totalApprovedAmount: 0,
      totalClaimAmount,
    });

    this.props.close();
  };

  acceptItem = (item) => {
    const approvedQty = Number(this.state.approvedQty[item.id] ?? 0);
    const price = Number(item.price ?? 0);
    const taxPer = Number(item.taxPercentage ?? 0);

    const base = approvedQty * price;
    const tax = (base * taxPer) / 100;
    const approvedAmount = base + tax;

    const approvedAmountTotal = this.props.ProductReturnDtls.reduce(
      (total, val) => {
        const vQty = val.id === item.id ? approvedQty : Number(val.approvedQntty ?? 0);
        const vPrice = Number(val.price ?? 0);
        const vTaxPer = Number(val.taxPercentage ?? 0);

        if (val.id !== item.id && val.orderStatus !== "approved") return total;

        const vBase = vQty * vPrice;
        const vTax = (vBase * vTaxPer) / 100;

        return total + vBase + vTax;
      },
      0,
    );

    const totalClaimAmount = this.props.ProductReturnDtls.reduce(
      (total, val) => total + Number(val.claimAmountWithTax ?? 0),
      0,
    );

    this.props.returnacceptOne({
      id: item.id,
      orderId: this.props.PurchaseReturnsToShow.item.id,
      approvedQntty: approvedQty,
      approvedAmount,
      taxAmount: tax,
      totalApprovedAmount: approvedAmountTotal,
      totalClaimAmount,
    });
  };

  rejectItem = (item) => {
    const approvedQty = Number(this.state.approvedQty[item.id] ?? 0);
    const approvedAmount = 0;

    // Calculate total approved amount (excluding the item being rejected)
    const approvedAmountTotal = this.props.ProductReturnDtls.reduce(
      (total, val) => {
        if (val.id === item.id) return total;
        if (val.orderStatus !== "approved") return total;

        const vQty = Number(val.approvedQntty ?? 0);
        const vPrice = Number(val.price ?? 0);
        const vTaxPer = Number(val.taxPercentage ?? 0);

        const vBase = vQty * vPrice;
        const vTax = (vBase * vTaxPer) / 100;

        return total + vBase + vTax;
      },
      0,
    );

    const totalClaimAmount = this.props.ProductReturnDtls.reduce(
      (total, val) => total + Number(val.claimAmountWithTax ?? 0),
      0,
    );

    this.props.returnrejectedOne({
      id: item.id,
      orderId: this.props.PurchaseReturnsToShow.item.id,
      approvedQntty: approvedQty,
      approvedAmount,
      taxAmount: 0,
      totalApprovedAmount: approvedAmountTotal,
      totalClaimAmount,
    });
  };

  render() {
    const { show, close, PurchaseReturnsToShow, ProductReturnDtls, ItemCount } =
      this.props;
    const { itempage, itemsperPage } = this.state;
    const { itemsPageClick, createPdf } = this;

    const data =
      PurchaseReturnsToShow && PurchaseReturnsToShow.item
        ? PurchaseReturnsToShow.item
        : null;
    const address = data
      ? [data.addr, data.pincode]
          .filter(
            (value) =>
              value !== undefined &&
              value !== null &&
              value !== "" &&
              value !== 0,
          )
          .join(", ")
      : "";

    const itemcount = ItemCount;
    let p1 = itempage + 1;
    let itemPageCount = Math.ceil(itemcount / itemsperPage);

    const approvedClaimTotal = Array.isArray(ProductReturnDtls)
      ? ProductReturnDtls.reduce(
        (total, val) => total + (Number(val.claimAmountWithTax) || 0),
        0,
      )
      : 0;

    const approvedAmountTotal = Array.isArray(ProductReturnDtls)
      ? ProductReturnDtls.reduce((total, val) => {
        // Only include items that are actually approved
        if (val.orderStatus !== "approved") return total;

        const qty = Number(val.approvedQntty ?? val.qntty);
        const price = Number(val.price ?? 0);
        const taxPer = Number(val.taxPercentage ?? 0);

        const base = qty * price;
        const tax = (base * taxPer) / 100;

        return total + base + tax;
      }, 0)
      : 0;

    const allItemsProcessed =
      Array.isArray(ProductReturnDtls) &&
      ProductReturnDtls.length > 0 &&
      ProductReturnDtls.every(
        (item) =>
          item.orderStatus === "approved" || item.orderStatus === "rejected",
      );

    const hasOrderStatus = ProductReturnDtls?.some(
      (item) => item.orderStatus !== undefined,
    );

    const hasMRP = ProductReturnDtls?.some(
      (item) => item.mrp !== undefined && item.mrp !== null,
    );

    const hasAnyItemProcessed =
      Array.isArray(ProductReturnDtls) &&
      ProductReturnDtls.some(
        (item) =>
          item.orderStatus === "approved" || item.orderStatus === "rejected",
      );

    // Allow closing modal anytime - user can come back to complete remaining items
    const canCloseModal = true;

    return (
      <div className="retunvieww">
        <div className="modelboxdesigns">
          <Modal
            show={show}
            onHide={close}
            animation={false}
            keyboard={false}
            size="xl"
            backdrop={false}
            className="Modalmodelboxdesigns"
            dialogClassName="custom-wide-modal"
            contentClassName="custom-wide-modal-content"
          >
            <Modal.Header
              style={{
                fontSize: "35px",
                backgroundColor: "#1768B7",
                color: "white",
              }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Expiry Return Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body id="check">
              {/* ===== HEADER DETAILS ===== */}
              <Row>
                <Col lg={6}>
                  <div className="chemistdetails">
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">Name :</span>{" "}
                      {data !== null && data.orderFrom
                        ? (data.orderFrom.fullName || (data.orderFrom.name + " " + data.orderFrom.lName))
                        : "-"}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">Mobile :</span>{" "}
                      {data?.orderFrom?.mobileNo || "-"}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">Email :</span>{" "}
                      {data?.chmstDtls?.email || "-"}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">Address :</span>{" "}
                      {address || "-"}
                    </p>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="chemistDtls">
                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">Order No :</span>{" "}
                      {data?.orderNo || "-"}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">Pharmacy :</span>{" "}
                      {data?.orderFrom?.orgName || data?.orderFromName || "-"}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">City :</span>{" "}
                      {data?.city || "-"}
                    </p>

                    <p className="chemistdetailspera">
                      <span className="chemistdetailshead">
                        Created Date :
                      </span>{" "}
                      {data?.createdAt
                        ? dateFormat(data.createdAt, "dd-mmm-yyyy")
                        : "-"}
                    </p>
                  </div>
                </Col>
              </Row>

              <div className="coomonlinebody">
                <hr />
              </div>

              {/* ===== ITEMS HEADER ===== */}
              <Row>
                <Col md={3}>
                  <h3 className="itemdetailshd">Item Details</h3>
                </Col>

                <Col md={9} style={{ textAlign: "right" }}>
                  <span className="cmnPageCount">
                    {itemcount !== undefined ? itemcount : 0}
                  </span>{" "}
                  <span className="cmnResutText">Items</span>
                </Col>
              </Row>

              {/* ===== ITEMS TABLE ===== */}
              <Card.Body>
                <div className="retunvieww">
                  <Table className="dashTable" responsive>
                    <thead className="tablecommonclr">
                      <tr>
                        <th>#</th>
                        <th>
                          <div style={{ textAlign: "start" }}>
                            <div style={{ fontWeight: "600" }}>Item Name</div>
                            <div style={{ fontSize: "12px", fontWeight: "400" }}>Item Code</div>
                          </div>
                        </th>
                        <th>
                          <div style={{ textAlign: "start" }}>
                            <div style={{ fontWeight: "600" }}>Batch No</div>
                            <div style={{ fontSize: "12px", fontWeight: "400" }}>Purchase Inv No</div>
                          </div>
                        </th>
                        <th>
                          <div style={{ textAlign: "start" }}>
                            <div style={{ fontWeight: "600" }}>Expiry Date</div>
                            <div style={{ fontSize: "12px", fontWeight: "400" }}>Purchase Date</div>
                          </div>
                        </th>
                        {hasMRP && <th>MRP</th>}
                        <th>Unit Price</th>
                        <th>Quantity</th>
                        <th>Approved Quantity</th>
                        <th>GST %</th>
                        <th>GST Amount</th>
                        <th>Offer/Scheme</th>
                        <th>Claim Amount</th>
                        <th>Approved Amount</th>
                        {data?.status !== "created" && hasOrderStatus && (
                          <th>Status</th>
                        )}
                        {data?.status === "created" && <th>Action</th>}
                      </tr>
                    </thead>

                    <tbody className="tablecommonclrtbody tableBody">
                      {ProductReturnDtls !== undefined &&
                        ItemCount !== 0 &&
                        ProductReturnDtls &&
                        ProductReturnDtls.map((val, i) => (
                          
                          <tr key={i}>
                            <th scope="row">{5 * (p1 - 1) + i + 1}</th>

                            <td className="cmn_Cap">
                              <div>
                                <div style={{ fontWeight: "600",  }}>
                                  {val?.itemName || "-"}
                                </div>
                                <div style={{ fontSize: "12px",  }}>
                                  {val?.itemCode?.drugCode || "-"}
                                </div>
                              </div>
                            </td>
                            <td className="cmn_Cap">
                              <div>
                                <div style={{ fontWeight: "600", }}>
                                  {val?.batchNo || "-"}
                                </div>
                                <div style={{ fontSize: "12px", }}>
                                  {val?.purchaseInvoiceNo || "-"}
                                </div>
                              </div>
                            </td>
                            <td className="cmn_Cap">
                              <div>
                                <div style={{ fontWeight: "600",}}>
                                  {val?.expiryDate
                                    ? dateFormat(val.expiryDate, "dd-mmm-yyyy")
                                    : "-"}
                                </div>
                                <div style={{ fontSize: "12px", }}>
                                  {val?.purchaseDate
                                    ? dateFormat(val.purchaseDate, "dd-mmm-yyyy")
                                    : "-"}
                                </div>
                              </div>
                            </td>
                             {hasMRP && (
                              <td className="cmn_Cap">{val.mrp && Number(val.mrp) !== 0 ? val.mrp : '-'}</td>
                            )}
                            <td className="cmn_Cap">{val?.price || "-"}</td>
                            <td className="cmn_Cap">{val?.qntty || 0}</td>

                            {val?.orderStatus === "created" ? (
                              <td>
                                <div className="radiobtnclass">
                                  <input
                                    type="text"
                                    min={0}
                                    max={val.qntty}
                                    className="textBox form-control"
                                    value={this.state.approvedQty[val.id] ?? ""}
                                    onChange={(e) => {
                                      const v = e.target.value;
                                      const num = Number(v);

                                      if (
                                        v !== "" &&
                                        (num < 0 || num > val.qntty)
                                      )
                                        return;

                                      this.setState((prev) => ({
                                        approvedQty: {
                                          ...prev.approvedQty,
                                          [val.id]: v === "" ? "" : num,
                                        },
                                      }));
                                    }}
                                  />
                                </div>
                              </td>
                            ) : (
                              <td>{val.approvedQntty ?? val.qntty}</td>
                            )}
                            <td className="cmn_Cap">{val?.taxPercentage || "-"}</td>
                            <td className="cmn_Cap">
                              {(() => {
                                const approvedQty =
                                  val?.orderStatus === "rejected"
                                    ? 0
                                    : val?.orderStatus === "created"
                                      ? Number(this.state.approvedQty[val.id] ?? 0)
                                      : Number(val.approvedQntty ?? val.qntty);

                                const price = Number(val.price ?? 0);
                                const taxPer = Number(val.taxPercentage ?? 0);

                                const taxAmount = (approvedQty * price * taxPer) / 100;

                                return taxAmount.toFixed(2);
                              })()}
                            </td>
                            {this.renderOfferCell(val?.offer)}
                            <td className="cmn_Cap">{val?.claimAmountWithTax}</td>
                            <td className="cmn_Cap">
                              {(() => {
                                const approvedQty =
                                  val?.orderStatus === "rejected"
                                    ? 0
                                    : val?.orderStatus === "created"
                                      ? Number(this.state.approvedQty[val.id] ?? 0)
                                      : Number(val.approvedQntty ?? val.qntty);

                                const price = Number(val.price ?? 0);
                                const taxPer = Number(val.taxPercentage ?? 0);

                                const base = approvedQty * price;
                                const tax = (base * taxPer) / 100;

                                return (base + tax).toFixed(2);
                              })()}
                            </td>

                            {(val?.orderStatus === "approved" ||
                              val?.orderStatus === "rejected") && (
                              <td className="cmn_Cap">
                                {val.orderStatus === "approved"
                                  ? "Accepted"
                                  : "Rejected"}
                              </td>
                            )}

                            {val?.orderStatus === "created" && (
                              <td className="cmn_Cap">
                                <div className="action-chip-group">
                                  <button
                                    className={`action-chip approve ${val.orderStatus === "approved"
                                      ? "active"
                                      : ""
                                      }`}
                                    disabled={val.orderStatus === "approved"}
                                    onClick={() => this.acceptItem(val)}
                                  >
                                    {val.orderStatus === "approved"
                                      ? "APPROVED"
                                      : "APPROVE"}
                                  </button>

                                  <button
                                    className={`action-chip reject ${val.orderStatus === "rejected"
                                      ? "active"
                                      : ""
                                      }`}
                                    disabled={val.orderStatus === "rejected"}
                                    onClick={() => this.rejectItem(val)}
                                  >
                                    {val.orderStatus === "rejected"
                                      ? "REJECTED"
                                      : "REJECT"}
                                  </button>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))}
                    </tbody>
                  </Table>

                  {/* TOTALS */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      padding: "12px 10px",
                      fontWeight: "bold",
                      fontSize: "15px",
                      borderTop: "1px solid #ddd",
                      marginTop: "10px",
                    }}
                  >
                    <span style={{ marginRight: "10px" }}>
                      Total Claim Amount :
                    </span>
                    <span style={{ color: "#1768B7" }}>
                      ₹ {(data?.totalClaimAmount||0).toFixed(2)}
                    </span>
                  </div>

                  {(data?.status === "accepted" ||
                    data?.status === "created" || data?.status === "pending") && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          padding: "12px 10px",
                          fontWeight: "bold",
                          fontSize: "15px",
                          borderTop: "1px solid #ddd",
                          marginTop: "10px",
                        }}
                      >
                        <span style={{ marginRight: "10px" }}>
                          Total Approved Amount :
                        </span>
                        <span style={{ color: "#1768B7" }}>
                          ₹ {(data?.totalApprovedAmount||0).toFixed(2)}
                        </span>
                      </div>
                    )}

                  {data?.prcpNotes && (
                    <div
                      style={{
                        marginTop: "14px",
                        padding: "14px 16px",
                        backgroundColor: "#F5F9FF",
                        borderLeft: "4px solid #1768B7",
                        borderRadius: "6px",
                        fontSize: "14px",
                        color: "#333",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "600",
                          marginBottom: "6px",
                          color: "#1768B7",
                        }}
                      >
                        📝 Purchase Notes
                      </div>
                      <div style={{ lineHeight: "1.6" }}>{data.prcpNotes}</div>
                    </div>
                  )}

                  {/* ===== PAGINATION ===== */}
                  {itemPageCount > 1 && (
                    <div className="paginationDiv">
                      <ReactPaginate
                        forcePage={itempage}
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        pageCount={itemPageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={itemsPageClick}
                        containerClassName={"pagination flex-wrap"}
                        activeClassName={"active"}
                      />
                    </div>
                  )}

                  {/* ===== NO DATA ===== */}
                  {(ProductReturnDtls === undefined ||
                    (ProductReturnDtls && ItemCount === 0)) && (
                      <div>
                        <div className="noDataImgDiv">
                          <Image
                            className="noDataImg"
                            src={require("../../assets/img/nodata4.png")}
                          />
                        </div>
                        <div className="noDataTextDiv">
                          No Items Found
                        </div>
                      </div>
                    )}
                </div>
              </Card.Body>
            </Modal.Body>

            {/* ===== FOOTER ===== */}
            <Modal.Footer style={{ backgroundColor: "#1768B7" }}>
              {(data?.status === "created" || data?.status === "accepted") && (
                <Button className="queryBtn me-2" onClick={createPdf}>
                  Download as PDF
                </Button>
              )}

              {data?.status === "created" && (
                <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    className="queryBtn me-2"
                    onClick={this.reject}
                    disabled={hasAnyItemProcessed}
                  >
                    Reject All
                  </Button>
                  <Button
                    className="queryBtnaccept me-2"
                    onClick={this.accept}
                    disabled={hasAnyItemProcessed}
                  >
                    Accept All
                  </Button>
                  <Button
                    className="queryBtn me-2"
                    onClick={this.props.close}
                    disabled={!canCloseModal}
                  >
                    Save
                  </Button>
                </div>
              )}

              {data?.status === "accepted" && (
                <div style={{ display: "flex", gap: "10px" }}>
                  <Button className="queryBtn me-2" onClick={this.exportToExcel}>
                    Download as Excel
                  </Button>
                  <Button className="queryBtn" onClick={close}>
                    Close
                  </Button>
                </div>
              )}

              {data && !["created", "accepted"].includes(data.status) && (
                <Button className="queryBtn" onClick={close}>
                  Close
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </div>
      </div >
    );
  }
}

export default ExpiryReturnsView;
